const madaBinRanges = [
  446404, 440795, 440647, 421141, 474491, 588845, 968208, 457997, 457865,
  468540, 468541, 468542, 468543, 417633, 446393, 636120, 968201, 410621,
  409201, 403024, 458456, 462220, 968205, 455708, 484783, 588848, 455036,
  968203, 486094, 486095, 486096, 504300, 440533, 489318, 489319, 445564,
  968211, 410685, 406996, 432328, 428671, 428672, 428673, 968206, 446672,
  543357, 434107, 407197, 407395, 42689700, 412565, 431361, 604906, 521076,
  588850, 968202, 529415, 535825, 543085, 524130, 554180, 549760, 968209,
  524514, 529741, 537767, 535989, 536023, 513213, 520058, 558563, 605141,
  968204, 422817, 422818, 422819, 410834, 428331, 483010, 483011, 483012,
  589206, 968207, 406136, 419593, 439954, 407520, 530060, 531196, 420132,
  242030, 22402030, 442463,
];

export function getCreditCardType(number: string) {
  if (!number) return "Unknown";

  // Check for Mada
  if (madaBinRanges.some((bin) => number.startsWith(bin.toString()))) {
    return "Mada";
  }

  // Check for Visa
  if (/^4/.test(number)) {
    return "Visa";
  }

  // Check for Mastercard
  if (/^5[1-5]/.test(number) || /^2(?:2[2-9]|[3-6][0-9]|7[0-1])/.test(number)) {
    return "MasterCard";
  }

  // Return Unknown if the card type is not recognized
  return "Unknown";
}

const BASE_ORIGIN = import.meta.env.VITE_VAULT_FRAME_URL;

export const getCardImageUrl = (cardNumber: string) => {
  const type = getCreditCardType(cardNumber);
  return `${BASE_ORIGIN}/images/${type}.svg`;
};

export function mapSavedCards(savedCards: SavedCard[]) {
  return savedCards.map((card) => {
    const cardType = getCreditCardType(card.bin);
    if (cardType === "Unknown") return card;
    return {
      ...card,
      logo: getCardImageUrl(card.bin),
      brand: cardType,
    };
  });
}
